/* Delegation survives Shopify section/product replacement. */
(() => {
  if (window.mcPdpBenefitsBound) return;
  window.mcPdpBenefitsBound = true;
  const setOpen = (entry, open) => {
    entry.querySelector('[data-mc-promise-trigger]').setAttribute('aria-expanded', String(open));
    entry.querySelector('[data-mc-promise-panel]').hidden = !open;
  };
  const closeOthers = except => document.querySelectorAll('[data-mc-promise]').forEach(entry => {
    if (entry !== except) setOpen(entry, false);
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-mc-promise-trigger]');
    if (trigger) {
      const entry = trigger.closest('[data-mc-promise]');
      closeOthers(entry);
      setOpen(entry, trigger.getAttribute('aria-expanded') !== 'true');
    } else if (!event.target.closest('[data-mc-promise]')) closeOthers();
  });
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    const entry = event.target.closest('[data-mc-promise]');
    if (entry && !entry.contains(event.relatedTarget)) { closeOthers(entry); setOpen(entry, true); }
  });
  document.addEventListener('pointerout', event => {
    if (event.pointerType !== 'mouse') return;
    const entry = event.target.closest('[data-mc-promise]');
    if (entry && !entry.contains(event.relatedTarget) && !entry.contains(document.activeElement)) setOpen(entry, false);
  });
  document.addEventListener('focusout', event => {
    const entry = event.target.closest('[data-mc-promise]');
    if (entry && !entry.contains(event.relatedTarget)) setOpen(entry, false);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeOthers();
  });
})();
